export const variablesTranslete = {
  driver: 'Водитель',
  investor: 'Инвестор',
  car: 'Машина',
  fine: 'Штраф',
  default: 'Стандартные',
  schedule: 'Расписание',
}
